<div class="chaneNamePopup">
    <div class="header">
        <img src="assets\images\steps\mark-bad.svg">
        <img class="pointer" (click)="close()" src="assets\images\close.svg">
    </div>
    <div class="name">
        <span *ngIf="error == statusValidation.Error" translate>mandatoryQuestionsErrorSend</span>
        <span *ngIf="error == statusValidation.NotValid" translate>invalidAnswersErrorSend</span>
    </div>
</div>